import apiService from './ApiService';

class SelfRegisterService {

    constructor () {}

    async getFlows(accountId){
        const response = await apiService.get(`/selfregister/v1/${accountId}/flows`);
        return response.data;    
    }

    async createFlow(accountId, data){
        const response = await apiService.post(`/selfregister/v1/${accountId}/flows`, data, { headers : { 'content-type': 'application/json' } });
        return response.data;
    }

    async updateFlow(accountId, flowId, data){
        const response = await apiService.put(`/selfregister/v1/${accountId}/flows/${flowId}`, data, { headers : { 'content-type': 'application/json' } });
        return response.data;
    }

    async removeFlow(accountId, flowId){
        await apiService.delete(`/selfregister/v1/${accountId}/flows/${flowId}`);
    }

    async getImages(accountId){
        const response = await apiService.get(`/selfregister/v1/${accountId}/images`);
        return response.data;    
    }

    async getImage(accountId, imageId){
        return await apiService.get(`/selfregister/v1/${accountId}/images/${imageId}/media`,{ responseType: "blob" });
    }

    async createImage(accountId, name){
        const response = await apiService.post(`/selfregister/v1/${accountId}/images`, { name }, { headers : { 'content-type': 'application/json' } });
        return response.data;    
    }

    async uploadImageMedia(accountId, imageId, file){
        const res = await window.fetch(`/selfregister/v1/${accountId}/images/${imageId}/media`, {
            method: 'POST',
            body: file,
            credentials: 'same-origin'
        });
        if(!res.ok){
            const text = await res.text().catch(() => '');
            throw new Error(`Falha ao enviar imagem: ${res.status} ${text}`);
        }
        return await res.json();
    }

    async getDocuments(accountId){
        const response = await apiService.get(`/selfregister/v1/${accountId}/documents`);
        return response.data;    
    }

    async createDocument(accountId, document){
        const response = await apiService.post(`/selfregister/v1/${accountId}/documents`, document, { headers : { 'content-type': 'application/json' } });
        return response.data;    
    }

    async getPublicDocuments(){
        const response = await apiService.get(`/selfregister/v1/documents/public`);
        return response.data;    
    }

    async getGuests(accountId, inviteId){ 
        const inviteQueryParam = inviteId ? `?inviteId=${inviteId}` : '';
        const response = await apiService.get(`/selfregister/v1/${accountId}/guests${inviteQueryParam}`);
        return response.data;    
    }

    async getInvitesByDay(accountId, year, month, day){ 
        const response = await apiService.get(`/selfregister/v1/${accountId}/invites?year=${year}&month=${month}&day=${day}`);
        return response.data;    
    }

    async getInvites(accountId){ 
        const response = await apiService.get(`/selfregister/v1/${accountId}/invites`);
        return response.data;    
    }

    async updateAllInvitesToDefaultFlow(accountId){
        const response = await apiService.post(`/selfregister/v1/${accountId}/invites/update-flow/default`, {} , { headers : { 'content-type': 'application/json' } });
        return response.data;
    }

    async getInvite(accountId, inviteId){ 
        const response = await apiService.get(`/selfregister/v1/${accountId}/invites/${inviteId}`);
        return response.data;    
    }

    async removeInvite(accountId, inviteId){
        await apiService.delete(`/selfregister/v1/${accountId}/invites/${inviteId}`);
    }

    async createInvite(accountId, data){
        await apiService.post(`/selfregister/v1/${accountId}/invites`, data, {  headers : { 'content-type': 'application/json' } });
    }

    async updateInvite(data){
        await apiService.put(`/selfregister/v1/${data.accountId}/invites/${data.id}`, data, {  headers : { 'content-type': 'application/json' } });
    }    

    async getResponsibles(accountId){ 
        const response = await apiService.get(`/selfregister/v1/${accountId}/responsibles`);
        return response.data;    
    }   

    async createResponsibleList(accountId, data){
        await apiService.post(`/selfregister/v1/${accountId}/responsibles`, data, {  headers : { 'content-type': 'application/json' } });
    }

    async updateResponsibleList(data){
        await apiService.put(`/selfregister/v1/${data.accountId}/responsibles/${data.id}`, data, {  headers : { 'content-type': 'application/json' } });
    }  

    async removeResponsibleList(accountId, listId){
        await apiService.delete(`/selfregister/v1/${accountId}/responsibles/${listId}`);
    }

    async removeGuest(accountId, guestId){
        await apiService.delete(`/selfregister/v1/${accountId}/guests/${guestId}`);
    }   
    
    async getGuestPhoto(accountId, guestId){ 
        const response = await apiService.get(`/selfregister/v1/${accountId}/guests/${guestId}/media`, { responseType: "arraybuffer" });
        return response.data;    
    }  

    

}

export default new SelfRegisterService();